function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
var _marked = /*#__PURE__*/_regeneratorRuntime().mark(processAndSetInteropCodes);
import { call, put, select, take } from 'redux-saga/effects';
import { eventChannel } from 'redux-saga';
import { initApplicationFailure, setConnectorConfigKo, setConnectorConfigOk, setDmpParameters, setInteropCodes, setModalError, dmpCommandSuccessContextualizedType, dmpCommandFailureContextualizedType, setPersistedConnectorConfiguration, setNosCodes } from '../actions';
import { setupSocket } from './connectorSagas';
import { getDmpConnectJSHost, getDmpConnectJSPort, getDmpConnectJSProtocol, getEsRestHost } from '../helpers/accessors';
import { createError, errorTypes, softwareErrors } from '../errors';
import getCommandAction from '../actions/config/generateCommands';
import commands from '../actions/config/commands';
import { apiSections } from '../constants';
import { formatInteropCodesParams } from '../actions/config/commandParamsFormatters';
import KJUR from "jsrsasign";
import { generateId } from '../utils/dataUtils';
var apiCodesToAppCodes = function apiCodesToAppCodes(array, validityField) {
  return array ? array.map(function (item) {
    return {
      code: item.s_code,
      label: item.s_displayName,
      oid: item.s_codeSystem || undefined,
      valid: !validityField || item[validityField] === undefined || item[validityField] === 1
    };
  }) : [];
};
var processInteropCodes = function processInteropCodes(codes) {
  var practiceSettings = codes.practiceSettings,
    healthcareSettings = codes.healthcareSettings,
    docTypes = codes.docTypes,
    docTypesTranslation = codes.docTypesTranslation,
    docCategories = codes.docCategories,
    docTypeToDocCategory = codes.docTypeToDocCategory,
    activitySectors = codes.activitySectors,
    professions = codes.professions,
    physicianSpecialities = codes.physicianSpecialities,
    adeliSpecialties = codes.adeliSpecialties,
    amoSpecialties = codes.amoSpecialties; // grouper les catégories
  var typeToCategory = docTypeToDocCategory.reduce(function (acc, curr) {
    (acc[curr.s_category] = acc[curr.s_category] || []).push(curr.s_type);
    return acc;
  }, {});
  return {
    adeliSpecialties: apiCodesToAppCodes(adeliSpecialties),
    amoSpecialties: apiCodesToAppCodes(amoSpecialties),
    activitySectors: apiCodesToAppCodes(activitySectors),
    practiceSettings: apiCodesToAppCodes(practiceSettings),
    healthcareSettings: apiCodesToAppCodes(healthcareSettings),
    professions: apiCodesToAppCodes(professions),
    physicianSpecialities: apiCodesToAppCodes(physicianSpecialities),
    categories: apiCodesToAppCodes(docTypes, 'i_validAlimentation'),
    docTypesTranslation: docTypesTranslation,
    metaCategories: docCategories.map(function (item) {
      return {
        code: item.s_code,
        label: item.s_displayName,
        types: apiCodesToAppCodes(docTypes.filter(function (type) {
          return typeToCategory[item.s_code].includes(type.s_code);
        }), 'i_validAlimentation')
      };
    })
  };
};
export function processAndSetInteropCodes(result) {
  var _result$data, practiceSettings, healthcareSettings, docTypes, docTypesTranslation, docCategories, docTypeToDocCategory, activitySectors, professions, physicianSpecialities, adeliSpecialties, amoSpecialties, processedCodes;
  return _regeneratorRuntime().wrap(function processAndSetInteropCodes$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        _result$data = result.data, practiceSettings = _result$data.practiceSettings, healthcareSettings = _result$data.healthcareSettings, docTypes = _result$data.docTypes, docTypesTranslation = _result$data.docTypesTranslation, docCategories = _result$data.docCategories, docTypeToDocCategory = _result$data.docTypeToDocCategory, activitySectors = _result$data.activitySectors, professions = _result$data.professions, physicianSpecialities = _result$data.physicianSpecialities, adeliSpecialties = _result$data.adeliSpecialties, amoSpecialties = _result$data.amoSpecialties;
        processedCodes = processInteropCodes({
          practiceSettings: practiceSettings,
          healthcareSettings: healthcareSettings,
          docTypes: docTypes,
          docTypesTranslation: docTypesTranslation,
          docCategories: docCategories,
          docTypeToDocCategory: docTypeToDocCategory,
          activitySectors: activitySectors,
          professions: professions,
          physicianSpecialities: physicianSpecialities,
          adeliSpecialties: adeliSpecialties,
          amoSpecialties: amoSpecialties
        });
        _context.next = 4;
        return put(setInteropCodes(processedCodes));
      case 4:
      case "end":
        return _context.stop();
    }
  }, _marked);
}
export var openDmpconnectJSWS = function openDmpconnectJSWS(hostname, port) {
  var webSocket = setupSocket(hostname, port);
  return new Promise(function (resolve, reject) {
    var timeout = setTimeout(function () {
      webSocket.close();
      reject(new Error('Timeout for Promise'));
      console.error('===============================');
      console.error('timeout when trying to connect to the WebSocket Server');
      console.error('===============================');
    }, 2000);
    webSocket.onopen = function () {
      webSocket.close();
      clearTimeout(timeout);
      resolve();
    };
  });
};
function testDMPConnectJS(hostname, port) {
  return eventChannel(function (emitter) {
    openDmpconnectJSWS(hostname, port).then(function () {
      return emitter({
        connected: true
      });
    }, function () {
      return emitter({
        connected: false
      });
    });
    var timer = setInterval(function () {
      openDmpconnectJSWS(hostname, port).then(function () {
        return emitter({
          connected: true
        });
      }, function () {
        return emitter({
          connected: false
        });
      });
    }, 3000);
    // The subscriber must return an unsubscribe function
    return function () {
      clearInterval(timer);
    };
  });
}
export var checkConnector = function checkConnector(_ref) {
  var _ref$retries = _ref.retries,
    retries = _ref$retries === void 0 ? 20 : _ref$retries;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var dmpcjsProtocol, dmpcjsHost, dmpcjsPort, channel, i, stop, _yield$take, connected, error;
    return _regeneratorRuntime().wrap(function _callee$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return select(getDmpConnectJSProtocol);
        case 2:
          dmpcjsProtocol = _context2.sent;
          _context2.next = 5;
          return select(getDmpConnectJSHost);
        case 5:
          dmpcjsHost = _context2.sent;
          _context2.next = 8;
          return select(getDmpConnectJSPort);
        case 8:
          dmpcjsPort = _context2.sent;
          _context2.next = 11;
          return call(testDMPConnectJS, "".concat(dmpcjsProtocol, "://").concat(dmpcjsHost), dmpcjsPort);
        case 11:
          channel = _context2.sent;
          i = 0;
          stop = false;
        case 14:
          if (stop) {
            _context2.next = 40;
            break;
          }
          _context2.next = 17;
          return take(channel);
        case 17:
          _yield$take = _context2.sent;
          connected = _yield$take.connected;
          if (!(connected === true)) {
            _context2.next = 25;
            break;
          }
          _context2.next = 22;
          return put(setConnectorConfigOk());
        case 22:
          channel.close();
          _context2.next = 38;
          break;
        case 25:
          _context2.next = 27;
          return put(setConnectorConfigKo());
        case 27:
          if (!(retries >= 0 && i >= retries)) {
            _context2.next = 37;
            break;
          }
          _context2.next = 30;
          return put(initApplicationFailure());
        case 30:
          error = createError(errorTypes.SoftwareErrors, softwareErrors.WEBSOCKET_TIMEOUT);
          _context2.next = 33;
          return put(setModalError({
            error: error
          }));
        case 33:
          channel.close();
          stop = true;
          _context2.next = 38;
          break;
        case 37:
          i += 1;
        case 38:
          _context2.next = 14;
          break;
        case 40:
        case "end":
          return _context2.stop();
      }
    }, _callee);
  })();
};
export var handleGetInteropCodes = /*#__PURE__*/_regeneratorRuntime().mark(function handleGetInteropCodes() {
  var result;
  return _regeneratorRuntime().wrap(function handleGetInteropCodes$(_context3) {
    while (1) switch (_context3.prev = _context3.next) {
      case 0:
        _context3.next = 2;
        return put(getCommandAction(commands.getInteropCodes, apiSections.INTEROPCODES, formatInteropCodesParams(['healthcareSettings', 'practiceSettings', 'docTypes', 'docTypesTranslation', 'docCategories', 'docTypesToDocCategories', 'activitySectors', 'professions', 'physicianSpecialities', 'adeliSpecialties', 'amoSpecialties']), {
          silentError: true
        }));
      case 2:
        _context3.next = 4;
        return take([dmpCommandSuccessContextualizedType(apiSections.INTEROPCODES), dmpCommandFailureContextualizedType(apiSections.INTEROPCODES)]);
      case 4:
        result = _context3.sent;
        if (!(result && result.type === dmpCommandFailureContextualizedType(apiSections.INTEROPCODES))) {
          _context3.next = 7;
          break;
        }
        return _context3.abrupt("return", false);
      case 7:
        _context3.next = 9;
        return call(processAndSetInteropCodes, result);
      case 9:
        return _context3.abrupt("return", true);
      case 10:
      case "end":
        return _context3.stop();
    }
  }, handleGetInteropCodes);
});
export var handleGetNosCodes = /*#__PURE__*/_regeneratorRuntime().mark(function handleGetNosCodes() {
  var result;
  return _regeneratorRuntime().wrap(function handleGetNosCodes$(_context4) {
    while (1) switch (_context4.prev = _context4.next) {
      case 0:
        _context4.next = 2;
        return put(getCommandAction(commands.getNosCodes, apiSections.NOS_CODES, {
          TableNames: ['tre_r37-typeprofessionfonction']
        }));
      case 2:
        _context4.next = 4;
        return take(dmpCommandSuccessContextualizedType(apiSections.NOS_CODES));
      case 4:
        result = _context4.sent;
        _context4.next = 7;
        return put(setNosCodes(result.data));
      case 7:
      case "end":
        return _context4.stop();
    }
  }, handleGetNosCodes);
});
export var handleDmpParameters = /*#__PURE__*/_regeneratorRuntime().mark(function handleDmpParameters() {
  var result;
  return _regeneratorRuntime().wrap(function handleDmpParameters$(_context5) {
    while (1) switch (_context5.prev = _context5.next) {
      case 0:
        _context5.next = 2;
        return put(getCommandAction(commands.getDmpParameters, apiSections.DMP_PARAMETERS));
      case 2:
        _context5.next = 4;
        return take(dmpCommandSuccessContextualizedType(apiSections.DMP_PARAMETERS));
      case 4:
        result = _context5.sent;
        _context5.next = 7;
        return put(setDmpParameters(result.data));
      case 7:
      case "end":
        return _context5.stop();
    }
  }, handleDmpParameters);
});
export var generateAndSaveToken = /*#__PURE__*/_regeneratorRuntime().mark(function generateAndSaveToken(secret) {
  var connectorBaseURL, oHeader, oPayload, tNow, tEnd, sHeader, sPayload, sJWT;
  return _regeneratorRuntime().wrap(function generateAndSaveToken$(_context6) {
    while (1) switch (_context6.prev = _context6.next) {
      case 0:
        _context6.next = 2;
        return select(getEsRestHost);
      case 2:
        connectorBaseURL = _context6.sent;
        // Header
        oHeader = {
          alg: 'HS256',
          typ: 'JWT'
        }; // Payload
        oPayload = {};
        tNow = KJUR.jws.IntDate.get('now');
        tEnd = KJUR.jws.IntDate.get('now + 1day');
        oPayload.iss = connectorBaseURL;
        oPayload.sub = 'mailto:contact@icanopee.net';
        oPayload.nbf = tNow;
        oPayload.iat = tNow;
        oPayload.exp = tEnd;
        oPayload.jti = generateId(20);
        oPayload.aud = connectorBaseURL;
        sHeader = JSON.stringify(oHeader);
        sPayload = JSON.stringify(oPayload);
        sJWT = KJUR.jws.JWS.sign('HS256', sHeader, sPayload, secret);
        _context6.next = 19;
        return put(setPersistedConnectorConfiguration('connectorJWT', sJWT));
      case 19:
      case "end":
        return _context6.stop();
    }
  }, generateAndSaveToken);
});